/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Page_Compare_TitleInputs */

const en_cad_page_compare_title = /** @type {(inputs: Cad_Page_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft vs AutoCAD: Differences, Advantages & Which to Choose`)
};

/**
* | output |
* | --- |
* | "CADCraft vs AutoCAD: Differences, Advantages & Which to Choose" |
*
* @param {Cad_Page_Compare_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_page_compare_title = /** @type {((inputs?: Cad_Page_Compare_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Page_Compare_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_page_compare_title(inputs)
});
export { cad_page_compare_title as "cad.page.compare.title" }